import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { register } from '../services/auth.service';

const initialFormData = {
  name: '',
  email: '',
  password: '',
  slug: '',
  telegram_opt_in: true,
  accept_cgu: false,
};

export const useRegisterForm = () => {
  const [formData, setFormData] = useState(initialFormData);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(null);
  const [requiresVerification, setRequiresVerification] = useState(false);
  const [registeredEmail, setRegisteredEmail] = useState(null);

  const navigate = useNavigate();

  const slugify = (text) => {
    return text
      .toLowerCase()
      .trim()
      .normalize('NFD') // remove accents
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^\w\s-]/g, '') // remove non-word chars
      .replace(/[\s_-]+/g, '-') // replace spaces and underscores with -
      .replace(/^-+|-+$/g, ''); // trim - from ends
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => {
      const newData = {
        ...prev,
        [name]: type === 'checkbox' ? checked : value,
      };

      // Auto-generate slug if name changes
      if (name === 'name') {
        newData.slug = slugify(value);
      }

      return newData;
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    // Validation: CGU must be accepted
    if (!formData.accept_cgu) {
      setError('Vous devez accepter les Conditions Générales d\'Utilisation pour continuer.');
      setLoading(false);
      return;
    }

    try {
      const data = await register(formData);
      
      if (data.requiresVerification) {
        setRequiresVerification(true);
        setRegisteredEmail(data.email);
        setSuccess(true);
      } else {
        // Legacy flow (if verification is disabled)
        localStorage.setItem('token', data.token);
        localStorage.setItem('artist', JSON.stringify(data.artist));
        setSuccess(true);
        setTimeout(() => navigate('/dashboard'), 1200);
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleVerificationSuccess = (artist) => {
    localStorage.setItem('token', artist.token);
    localStorage.setItem('artist', JSON.stringify(artist));
    navigate('/dashboard');
  };

  const handleBackToRegister = () => {
    setRequiresVerification(false);
    setRegisteredEmail(null);
    setSuccess(false);
    setError(null);
  };

  return {
    formData,
    loading,
    success,
    error,
    requiresVerification,
    registeredEmail,
    handleChange,
    handleSubmit,
    handleVerificationSuccess,
    handleBackToRegister,
  };
};
